//import tim from '../../tim.js'
const custom = {
    namespaced: true,
    state: {
        get_resumes_id_ok: [],//同意发送简历请求列表id
        get_resumes_id_no: [],//拒绝发送简历请求列表id
        userData:{},//用户信息
        jobsData:{},//职位列表
        resumesData:{},//简历列表
        toUserData:{},//对方用户信息
        talk_list:[],//等待洽谈列表
        endTalkList:[],//结束洽谈列表
    },
    getters: {

    },
    mutations: {
        setGetResumesIdOk(state, data) {
            if (state.get_resumes_id_ok.indexOf(data)===-1) {
                state.get_resumes_id_ok = [...state.get_resumes_id_ok, data]
            }
        },
        setGetResumesIdNo(state, data) {
            if (state.get_resumes_id_no.indexOf(data)===-1) {
                state.get_resumes_id_no = [...state.get_resumes_id_no, data]
            }
        },
        setUserData(state, data) {
            state.userData = data
        },
        setJobsData(state, data) {
            state.jobsData = data
        },
        setResumesData(state, data) {
            state.resumesData = data
        },
        setToUserData(state, data) {
            state.toUserData = data
        },
        setTalkList(state, data) {
            state.talk_list = data
        },
        setEndTalkList(state, data) {
            if (state.endTalkList.indexOf(data)===-1) {
                state.endTalkList = [...state.endTalkList, data]
            }
        },
    },
    actions:{
        /**
         * 获取对方用户信息
         * @param context
         * @param param
         */
        /*chatUserInfo(context,param) {
            axios.post('/api/chat/net/chatUserInfo',{
                userId:param.toUserId,
                meId:param.userId,
            }).then(function (response) {
                const data = response.data.data
                const status = response.data.status
                if (status===200) {
                    context.commit('setToUserData',data)
                }else {
                    context.commit('showMessage', {
                        message: response.data.message,
                        type: 'error'
                    },{ root: true })
                }
            }).catch(function (error) {
                context.commit('showMessage', {
                    message:  error.response.data.message,
                    type: 'error'
                },{ root: true })
            })
        },*/
        /**
         * 更新等待洽谈列表
         * @param context
         * @param param
         */
        /*updateTalkList(context,param) {
            axios.post('/api/chat/net/talkListThree',{
                userId:param.userId,
            }).then(function (response) {
                const data = response.data.data
                const status = response.data.status
                if (status===200) {
                    context.commit('setTalkList',data)
                }else {
                    context.commit('showMessage', {
                        message: response.data.message,
                        type: 'error'
                    },{ root: true })
                }
            }).catch(function (error) {
                context.commit('showMessage', {
                    message:  error.response.data.message,
                    type: 'error'
                },{ root: true })
            })
        },*/

        /*endTalk(context,param) {
            axios.post('/api/chat/net/chatNetTalkEnd',{
                userId:param.userId,
                toUserId:param.toUserId,
                talk_id:param.talk_id,
                evaluate_id:param.evaluate_id,
                evaluate_status:param.evaluate_status,
            }).then(function (response) {
                const data = response.data.data
                const status = response.data.status
                if (status===200) {
                    tim.deleteConversation(param.conversationID)
                        .then(() => {
                            this.$store.commit('showMessage', {
                                message: `会话【${param.conversationName}】删除成功!`,
                                type: 'success'
                            })
                            context.commit('conversation/resetCurrentConversation')
                            context.commit('setToUserData',{})
                            context.commit('setTalkList',data)
                        })
                        .catch(error => {
                            context.commit('showMessage', {
                                message: `会话【${param.conversationName}】删除失败!, error=${error.message}`,
                                type: 'error'
                            })
                        })
                }else {
                    context.commit('showMessage', {
                        message: response.data.message,
                        type: 'error'
                    },{ root: true })
                }
            }).catch(function (error) {
                context.commit('showMessage', {
                    message:  error.response.data.message,
                    type: 'error'
                },{ root: true })
            })
        },*/
    }
}

export default custom
